import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { BreadcrumbLink, BreadcrumbPage } from '@/components/ui/breadcrumb';
import { RenderIf } from '@/components/RenderIf';
import { StaticCrumbProps } from './types';

const StaticCrumb = ({ label, href, isCurrentPage = false }: StaticCrumbProps) => {
    const params = useParams();

    let resolvedHref = href;

    // Replace :params in href with actual values
    if (resolvedHref) {
        resolvedHref = resolvedHref.replace(/:(\w+)/g, (_, param) => params[param] || '');
    }

    return (
        <>
            <RenderIf isTrue={isCurrentPage === true}>
                <BreadcrumbPage>
                    <div className="flex items-center gap-2">{label}</div>
                </BreadcrumbPage>
            </RenderIf>
            <RenderIf isTrue={!isCurrentPage && !!resolvedHref}>
                <BreadcrumbLink asChild>
                    <Link to={resolvedHref!}>
                        <div className="flex items-center gap-2">{label}</div>
                    </Link>
                </BreadcrumbLink>
            </RenderIf>
        </>
    );
};

export default StaticCrumb;
